import { useEffect, useRef } from 'react'
import { YhFormBox } from '@/components/YhFormBoxVertical'
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBoxVertical/Types'
import { message } from 'antd'
import { ISelectOptions } from '@/types/AppTypes'
import { YHModal } from '@/components/YHModal'
import { threeInspectionSchedulingModel } from '../schedulingModel'
import { globalPrompt } from '@/components/message'
import { schedulingService } from '../schedulingService'
import moment from 'moment'
import useGlobalModel from '@/model/globalModel'

export const EditSchedulingModal = () => {
    const { editCarVisible, setEditCarVisible, loadData } = threeInspectionSchedulingModel()
    const formRef = useRef<IYhFormRef>()
    const {
        vehicleData,
        trailerData,
        driverData,
        supercargoData,
        routineData
    } = useGlobalModel(({ user }) => [user])

    const onOk = () => {
        formRef.current?.validateFields().then(async (val) => {
            try {
                let { retData } = await schedulingService.edit({
                    ...editCarVisible.value,
                    ...val,
                    departureTime: moment(val.departureTime).format('YYYY-MM-DD HH:mm:ss'),
                    departureEndTime: moment(val.departureEndTime).format('YYYY-MM-DD HH:mm:ss'),
                    fatigue: val.fatigue === true ? 'YES' : 'NO',
                    alcoholTesting: val.alcoholTesting === true ? 'YES' : 'NO'
                })
                setEditCarVisible({
                    visible: false,
                    value: {}
                })
                message.success(`修改成功！`)
                loadData()
                return retData
            } catch (error) {
                message.warning(error)
            }
        })
    }

    useEffect(() => {
        formRef.current?.setFieldsValue({
            ...editCarVisible.value,
            departureTime: moment(editCarVisible.value.departureTime),
            departureEndTime: moment(editCarVisible.value.departureEndTime),
            fatigue: editCarVisible.value.fatigue === 'YES' ? true : false,
            alcoholTesting: editCarVisible.value.alcoholTesting === 'YES' ? true : false
        })
    }, [editCarVisible.value])
    const driverIdChange = (value: string, node: ISelectOptions) => {
        node && saveCache({ driverId: value, driverName: node.label, md5: node.md5, photo: node.photo })
    }
    const escortIdChange = (value: string, node: ISelectOptions) => {
        node && saveCache({ escortId: value, escortName: node.label, dualDrivers: node.type === '司机' ? 1 : 0 })
    }
    const vehicleIdChange = (value: string, node: ISelectOptions) => {
        node && saveCache({ vehicleId: value, vehicleNumber: node.label })
    }
    const trailerIdChange = (value: string, node: ISelectOptions) => {
        node && saveCache({ trailerId: value, trailerNumber: node.label })
    }
    const lineNameChange = (value: string, node: ISelectOptions) => {
        node && saveCache({ lineName: value })
    }

    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }) => {
        formRef.current?.setFieldsValue(val)
    }

    const formItem: IYhFormItemsBox = {
        title: '',
        style: { padding: '10px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Checkbox,
                fieldLabel: '疲劳检测',
                fieldName: 'fatigue',
                span: 24
            },
            {
                type: FormItemTypeEnum.Checkbox,
                fieldLabel: '酒精检测',
                fieldName: 'alcoholTesting',
                span: 24
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '司机',
                fieldName: 'driverId',
                options: driverData,
                span: 24,
                onSelectChange: driverIdChange,
                rules: [{ required: true, message: '请选择司机' }]
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '押运员',
                fieldName: 'escortId',
                options: [...supercargoData, ...driverData],
                span: 24,
                onSelectChange: escortIdChange
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '车头',
                fieldName: 'vehicleId',
                options: vehicleData,
                span: 24,
                onSelectChange: vehicleIdChange,
                rules: [{ required: true, message: '请选择车头' }]
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '挂车',
                fieldName: 'trailerId',
                options: trailerData,
                span: 24,
                onSelectChange: trailerIdChange
                // rules: [{ required: true, message: '请选择挂车' }],
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: '开始时间',
                fieldName: 'departureTime',
                format: 'YYYY-MM-DD HH:mm:ss',
                showTime: true,
                span: 24
                // disabledDate:disabledDate
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: '结束时间',
                fieldName: 'departureEndTime',
                format: 'YYYY-MM-DD HH:mm:ss',
                showTime: true,
                span: 24
                // disabledDate:disabledDate
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '路线',
                fieldName: 'lineName',
                options: routineData,
                span: 24,
                onSelectChange: lineNameChange
                // rules: [{ required: true, message: '请选择路线' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '修改人',
                fieldName: 'updateUser',
                span: 24
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '',
                fieldName: 'md5',
                span: 24,
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '',
                fieldName: 'photo',
                span: 24,
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '',
                fieldName: 'driverName',
                span: 24,
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '',
                fieldName: 'escortName',
                span: 24,
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '',
                fieldName: 'vehicleNumber',
                span: 24,
                hidden: true
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '',
                fieldName: 'trailerNumber',
                span: 24,
                hidden: true
            }
        ]
    }

    const onChange = (changedValues: { [key: string]: any }) => {
        saveCache(changedValues)
    }

    const FromConfig: IYhFormBox<any> = {
        formRef,
        labelAlign: 'right',
        // formValues: formVal,
        onChange,
        boxs: [formItem]
    }
    const onClose = () => {
        globalPrompt('modal', {
            title: '修改排班',
            type: 'warning',
            text: '您正在修改的排班记录还没保存...是否关闭？',
            okText: '确认关闭',
            onOk: () =>
                setEditCarVisible({
                    visible: false,
                    value: {}
                }),
            cancelText: '继续修改'
            // onCancel: () => {
            //     formRef.current?.resetFields()
            //     return
            // },
        })
    }
    return (
        <YHModal
            visible={editCarVisible.visible}
            title="您正在修改排班..."
            cancelText="取消修改"
            okText="确定修改"
            onCancel={onClose}
            onOk={onOk}
            width={500}
            showFooter={true}
        >
            <YhFormBox {...FromConfig} isShowHeader={false} />
        </YHModal>
    )
}
